import React, { useState, useEffect,useRef } from "react";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";

import instance from "../../api/api.js";
import { GoPlus } from "react-icons/go"
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { TabView, TabPanel } from "primereact/tabview";
// import { NavLink } from "react-router-dom";
// import { AiFillEye } from "react-icons/ai";
import { FilterMatchMode } from "primereact/api";
// import { InputText } from "primereact/inputtext";
// import { useNavigate } from "react-router-dom";
import { MenuPoint, ModalDelete } from "../../shared/compoments";
import { MdOutlineDelete } from "react-icons/md";
import AllCompomentShared from "../../shared/compoments/AllCompomentShared.jsx";
import { styleIcone } from "../../shared";
import { LiaCitySolid } from "react-icons/lia";

function Commodite() {
  // const navigate = useNavigate();
  const [biens, setCommodite] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    nom: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    email: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    phone: { value: null, matchMode: FilterMatchMode.EQUALS },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  useEffect(() => {
    const getListBiens = async () => {
      setIsLoading(true);
      try {
        const response = await instance.get("comodites");
        console.log("comodites", response.data.data);
        setCommodite(response.data.data);
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    };
    getListBiens();
  }, []);
  return (
    <AllCompomentShared
    libelleHeaderComp={"Liste des Commodités"}
    titleStatisticHeaderComp={"Nombre de commodités"}
    nbreTotalStatistiqueComp={biens.length}
    SearchTableNameRouteBtn={"/commodites/creation"}
     SearchTableLibelleBtn={"Nouvelle commodité"}
     SearchTableIconeBtn={<GoPlus />} //import { GoPlus } from "react-icons/go";
    SearchTableIsBtn={true}
    SearchTableIsSearch={true}
    placeholderInputSearch={"Recherche"}
    globalFilterValue={globalFilterValue}
    onGlobalFilterChange={onGlobalFilterChange}
    iconeStatistiqueHeader={<LiaCitySolid fontSize={"2em"}/>} 
    isLoading={isLoading}
  >
         <CommoditeDatatable items={biens} filters={filters} />
  </AllCompomentShared>
    // <div className="conteneur-page">
    //   <h1>Liste des Commodités</h1>
    //   <div className="text-end">
    //     <button
    //       onClick={() => navigate("/commodites/creation")}
    //       className="btn-lg bg-warning border-0 rounded-3 p-2 text-dark fw-bold"
    //     >
    //       Enregistrer
    //     </button>
    //   </div>
    //   {isLoading ? (
    //     <h1 className="text-center">Chargement...</h1>
    //   ) : (
    
    //   )}
    // </div>
  );
}

export function CommoditeDatatable({ items,filters }) {
  const dt = useRef(null);

  // const footer = `${items ? items.length : 0} Commodités.`;

  // const detailsInfo = (rowData) => {
  //   const styleBtn = {
  //     textDecoration: "none",
  //     cursor: "pointer",
  //     fontSize: "1em",
  //     color: "black",
  //   };
  //   return (
  //     <NavLink to={`/biens/${rowData.id}`} style={styleBtn}>
  //       <AiFillEye fontSize="1.5em" />
  //     </NavLink>
  //   );
  // };
  const [open,setOpen] = useState(false);
  const options = [
    {
      name: "Supprimer",
      icone: <MdOutlineDelete style={styleIcone} />,
      isIdData: true,
      addMethodClick: true,
        methode: (idData) => {
          isDeleteCity(idData);
        },
    },
  ];
  const isDeleteCity = (id) => {
    console.log(id);
    setOpen(true);
  };
  const detailsInfo = (rowData) => {
    return <MenuPoint optionMenu={options} idData={rowData.id} />;
  };

  
  return (
    <div>
       <ModalDelete
        modalTitle={"Voulez-vous vraiment supprimer cette commodité ?"}
        setOpenMethod={setOpen}
        openProp={open}
        dataInfoForBtn={
        [{
          libelleBtn:"Oui",
          color:"error",
          methode:()=>{
            console.log("dff")
            // if(isRejectedBtn){
            //   changeStatut('refuse',valueTextField)
            // }
            // if(!isRejectedBtn){
            //   changeStatut('accepter')
            // }
          }
        },{
          libelleBtn:"Non",
          isStyle:true,
          methode:()=>{
             console.log("dff")
            // dispatch(showModal())
          }
        }]
      }
      />
      <TabView>
        <TabPanel>
          <DataTable
            ref={dt}
            value={items}
            tableStyle={{ minWidth: "50rem" }}
            paginator
            rows={10}
            filters={filters}
            globalFilterFields={["label"]}
          >
            <Column
              field="label"
              style={{ textAlign: "center" }}
              header="Libellé"
            ></Column>

            <Column
              field="id"
              style={{ textAlign: "center" }}
              header="Action"
              body={detailsInfo}
            ></Column>
          </DataTable>
        </TabPanel>
      </TabView>
    </div>
  );
}


export default Commodite;

